import React, { Component } from 'react';
import Spinner from '../../common/Spinner/Spinner';
import Reviews from './Reviews';
import config from '../../../config';


class ReviewsContainer extends Component {
  state = {
    reviews: [],
    index: 0,
    next: false,
    disabled: false
  };

  async componentDidMount() {
    const res = await fetch(`${config.fetchURL}/velemenyek`);
    const data = await res.json();

    const reviews = data.map(review => ({
      name: review.title.rendered,
      text: review.acf.velemeny
    }));

    this.setState({ reviews });
  }

  nextReviewHandler = () => {
    this.setState(prevState => {
      const index = prevState.index < this.state.reviews.length - 1 ? prevState.index + 1 : 0;
      return {
        index,
        disabled: true,
        next: true
      };
    });

    setTimeout(() => {
      this.setState({ disabled: false });
    }, 500);
  }

  prevReviewHandler = () => {
    this.setState(prevState => {
      const index = prevState.index > 0 ? prevState.index - 1 : this.state.reviews.length - 1;
      return {
        index,
        disabled: true,
        next: false
      };
    });

    setTimeout(() => {
      this.setState({ disabled: false });
    }, 500);
  }

  render() {
    const { reviews, index, next } = this.state;

    if (reviews.length > 0) {
      return (
        <Reviews
          review={reviews[index]}
          nextHandler={this.nextReviewHandler}
          prevHandler={this.prevReviewHandler}
          disabled={this.state.disabled}
          index={index}
          count={reviews.length}
          next={next}
        />
      );
    } else {
      return (
        <section className="reviews">
          <Spinner style={{ marginTop: '126px', marginBottom: '126px' }} />
        </section>
      );
    }
  }
}


export default ReviewsContainer;



// WEBPACK FOOTER //
// ./src/components/Home/Reviews/ReviewsContainer.js